"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quoteFromName = exports.buildLoanBenchmarkQuote = exports.buildISINHCQuote = exports.buildISINQuote = exports.buildMMQuote = exports.buildConventionalFXQuote = exports.buildFXQuote = exports.Quote = exports.QuoteTenor = exports.QuoteTypes = void 0;
const currency_util_1 = require("./currency-util");
class QuoteTypes {
}
exports.QuoteTypes = QuoteTypes;
QuoteTypes.FX = 'FX';
QuoteTypes.MM = 'MM';
QuoteTypes.ISIN = 'ISIN';
QuoteTypes.ISINHC = 'ISINHC';
// public static readonly BOND_BENCHMARK = 'BONDBM';
QuoteTypes.LOAN_BENCHMARK = 'LOANBM';
class QuoteTenor {
}
exports.QuoteTenor = QuoteTenor;
QuoteTenor.TOD = 'TOD';
QuoteTenor.TOM = 'TOM';
QuoteTenor.SPOT = 'SPOT';
QuoteTenor.T_1D = '1D';
QuoteTenor.T_2D = '2D';
QuoteTenor.T_3D = '3D';
QuoteTenor.T_4D = '4D';
QuoteTenor.T_5D = '5D';
QuoteTenor.T_6D = '6D';
QuoteTenor.T_7D = '7D';
QuoteTenor.T_1W = '1W';
QuoteTenor.T_2W = '2W';
QuoteTenor.T_3W = '3W';
QuoteTenor.T_4W = '4W';
QuoteTenor.T_5W = '5W';
QuoteTenor.T_1M = '1M';
QuoteTenor.T_2M = '2M';
QuoteTenor.T_3M = '3M';
QuoteTenor.T_4M = '4M';
QuoteTenor.T_5M = '5M';
QuoteTenor.T_6M = '6M';
QuoteTenor.T_7M = '7M';
QuoteTenor.T_8M = '8M';
QuoteTenor.T_9M = '9M';
QuoteTenor.T_10M = '10M';
QuoteTenor.T_11M = '11M';
QuoteTenor.T_12M = '12M';
QuoteTenor.T_1Y = '1Y';
QuoteTenor.T_2Y = '2Y';
QuoteTenor.T_3Y = '3Y';
QuoteTenor.T_4Y = '4Y';
QuoteTenor.T_5Y = '5Y';
QuoteTenor.T_10Y = '10Y';
QuoteTenor.T_20Y = '20Y';
QuoteTenor.T_30Y = '30Y';
class Quote {
    constructor(name, quoteTenor, date, rate, quoteType) {
        this.name = name;
        this.quoteTenor = quoteTenor;
        this.date = date;
        this.rate = rate;
        this.quoteType = quoteType;
    }
}
exports.Quote = Quote;
function buildFXQuote(baseCurrency, quotingCurrency, tenor, date, qualifier) {
    let name = `${QuoteTypes.FX}.${baseCurrency.toUpperCase()}.${quotingCurrency.toUpperCase()}.${tenor.toUpperCase()}`;
    if (qualifier) {
        name += `.${qualifier.toUpperCase()}`;
    }
    return new Quote(name, tenor, date, 0.0, QuoteTypes.FX);
}
exports.buildFXQuote = buildFXQuote;
function buildConventionalFXQuote(baseCurrency, quotingCurrency, tenor, date, qualifier) {
    if (currency_util_1.CurrencyUtil.isFXQuoteConvention(baseCurrency, quotingCurrency)) {
        return buildFXQuote(baseCurrency, quotingCurrency, tenor, date, qualifier);
    }
    else {
        return buildFXQuote(quotingCurrency, baseCurrency, tenor, date, qualifier);
    }
}
exports.buildConventionalFXQuote = buildConventionalFXQuote;
function buildMMQuote(currency, tenor, date, qualifier) {
    let name = `${QuoteTypes.MM}.${currency.toUpperCase()}.${tenor.toUpperCase()}`;
    if (qualifier) {
        name += `.${qualifier.toUpperCase()}`;
    }
    return new Quote(name, tenor, date, 0.0, QuoteTypes.MM);
}
exports.buildMMQuote = buildMMQuote;
function buildISINQuote(isin, date, qualifier) {
    let name = `${QuoteTypes.ISIN}.${isin.toUpperCase()}`;
    if (qualifier) {
        name += `.${qualifier.toUpperCase()}`;
    }
    return new Quote(name, QuoteTenor.SPOT, date, 0.0, QuoteTypes.ISIN);
}
exports.buildISINQuote = buildISINQuote;
function buildISINHCQuote(isin, date, source, qualifier) {
    let name = `${QuoteTypes.ISINHC}.${isin.toUpperCase()}.${source.toUpperCase()}`;
    if (qualifier) {
        name += `.${qualifier.toUpperCase()}`;
    }
    return new Quote(name, QuoteTenor.SPOT, date, 0.0, QuoteTypes.ISINHC);
}
exports.buildISINHCQuote = buildISINHCQuote;
// export function buildBondBenchmarkQuote(currency: string, tenor: string, date: string, qualifier?: string): Quote {
//     let name = `${QuoteTypes.BOND_BENCHMARK}.${currency.toUpperCase()}.${tenor.toUpperCase()}`;
//     if (qualifier) {
//         name += `.${qualifier.toUpperCase()}`;
//     }
//     return new Quote(name, tenor, date, 0.0, QuoteTypes.BOND_BENCHMARK);
// }
function buildLoanBenchmarkQuote(currency, tenor, date, qualifier) {
    let name = `${QuoteTypes.LOAN_BENCHMARK}.${currency.toUpperCase()}.${tenor.toUpperCase()}`;
    if (qualifier) {
        name += `.${qualifier.toUpperCase()}`;
    }
    return new Quote(name, tenor, date, 0.0, QuoteTypes.LOAN_BENCHMARK);
}
exports.buildLoanBenchmarkQuote = buildLoanBenchmarkQuote;
function quoteFromName(quoteName, date) {
    const splits = quoteName.split('.');
    const quoteType = splits[0];
    let optionalQualifier;
    if (quoteType === QuoteTypes.FX) {
        if (splits.length === 5) {
            optionalQualifier = splits[4];
        }
        return buildFXQuote(splits[1], splits[2], splits[3], date, optionalQualifier);
    }
    else if (quoteType === QuoteTypes.MM) {
        if (splits.length === 4) {
            optionalQualifier = splits[3];
        }
        return buildMMQuote(splits[1], splits[2], date, optionalQualifier);
    }
    else if (quoteType === QuoteTypes.ISIN) {
        if (splits.length === 3) {
            optionalQualifier = splits[2];
        }
        return buildISINQuote(splits[1], date, optionalQualifier);
    }
    else if (quoteType === QuoteTypes.ISINHC) {
        if (splits.length === 4) {
            optionalQualifier = splits[3];
        }
        return buildISINHCQuote(splits[1], date, splits[2], optionalQualifier);
    }
    else if (quoteType === QuoteTypes.LOAN_BENCHMARK) {
        if (splits.length === 4) {
            optionalQualifier = splits[3];
        }
        return buildLoanBenchmarkQuote(splits[1], splits[2], date, optionalQualifier);
    }
    else {
        throw new Error(`Unsupported QuoteType: ${quoteType}`);
    }
}
exports.quoteFromName = quoteFromName;
//# sourceMappingURL=market-data.js.map